import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateOutlookCalendarEventFromMeetingMutationVariables = Types.Exact<{
  data: Types.CreateOutlookCalendarEventFromMeetingInput;
}>;


export type CreateOutlookCalendarEventFromMeetingMutation = { createOutlookCalendarEventFromMeeting: { redirectUrl?: string | null, success?: boolean | null } };


export const CreateOutlookCalendarEventFromMeetingDocument = /*#__PURE__*/ gql`
    mutation CreateOutlookCalendarEventFromMeeting($data: CreateOutlookCalendarEventFromMeetingInput!) {
  createOutlookCalendarEventFromMeeting(data: $data) {
    redirectUrl
    success
  }
}
    `;

export function useCreateOutlookCalendarEventFromMeetingMutation() {
  return Urql.useMutation<CreateOutlookCalendarEventFromMeetingMutation, CreateOutlookCalendarEventFromMeetingMutationVariables>(CreateOutlookCalendarEventFromMeetingDocument);
};